import { Card, CardBody } from "@heroui/react";
import React from "react";
import { AccountDropdown } from "../ui/account-dropdown";

export const Menu = () => {
  return (
    <nav className="my-4 flex justify-end hidden">
      <Card>
        <CardBody>
          <AccountDropdown></AccountDropdown>
        </CardBody>
      </Card>
    </nav>
  );
};
